"use strict";

var _es6Promise = require("es6-promise");

var _util = require("./util");

var _nanoKONTROL = require("./devices/nanoKONTROL");

var _nanoKONTROL2 = _interopRequireDefault(_nanoKONTROL);

var _nanoKONTROL3 = require("./devices/nanoKONTROL2");

var _nanoKONTROL4 = _interopRequireDefault(_nanoKONTROL3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = require("debug")("korg-nano-kontrol");

var Devices = [_nanoKONTROL2.default, _nanoKONTROL4.default];

module.exports.connect = function (deviceName) {
  switch ((0, _util.getEnv)()) {
    case "browser":
      return connectWebMidi(deviceName);
    case "nodejs":
      return connectNodeMidi(deviceName);
  }
};

function connectWebMidi(deviceName) {
  debug("connectWebMidi(" + deviceName + ")");
  return new _es6Promise.Promise(function (resolve, reject) {
    if (navigator && typeof navigator.requestMIDIAccess !== "function") {
      return reject(new Error("Web MIDI API is not supported"));
    }
    var devices = Devices.filter(function (i) {
      return !deviceName || i.deviceName === deviceName;
    });
    navigator.requestMIDIAccess().then(function (webMidi) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = webMidi.inputs.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var input = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = devices[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var Device = _step2.value;

              if (Device.detect(input.name)) {
                debug("detect " + Device.name);
                return resolve(new Device(input, input.name));
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return reject("device not found");
    });
  });
}

function connectNodeMidi(deviceName) {
  var midi = require("midi");
  debug("connectNodeMidi(" + deviceName + ")");
  return new _es6Promise.Promise(function (resolve, reject) {
    var input = new midi.input();
    var devices = Devices.filter(function (device) {
      return !deviceName || device.deviceName === deviceName;
    });

    for (var i = 0; i < input.getPortCount(); i++) {
      var name = input.getPortName(i);
      debug("found device [" + i + "] \"" + name + "\"");

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = devices[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var Device = _step3.value;

          if (Device.detect(name)) {
            debug("detect \"" + Device.name + "\"");
            debug("openPort " + i);
            input.openPort(i);
            return resolve(new Device(input, name));
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
    return reject("device not found");
  });
}
//# sourceMappingURL=data:application/json;base64,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


/*****************
 ** WEBPACK FOOTER
 ** ./~/korg-nano-kontrol/lib/korg-nano-kontrol.js
 ** module id = 2
 ** module chunks = 2
 **/